import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

import { useApolloClient } from "react-apollo";

import gql from "graphql-tag";

import { Field, Title, Control, Button, Icon } from "rbx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import FormattedDirections from "./FormattedDirections";
import { printDirections } from "../../utils/export";
import { ourToast as toast } from "../../utils";

const ALL_DIRECTIONS_QUERY = gql`
  query ALL_DIRECTIONS_QUERY($where: DirectionWhereInput) {
    Directions(where: $where) {
      RecId
      Priority
      Directions
      LoadedMiles
      OriginLocation {
        RecId
        LocationID
        LocationName
        City
        State
      }
      DestinationLocation {
        RecId
        LocationID
        LocationName
        City
        State
      }
    }
  }
`;

const useDirections = where => {
  const [directions, setDirections] = useState([]);
  const [loading, setLoading] = useState(false);
  const client = useApolloClient();

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const { data: DirectionData } = await client.query({
          query: ALL_DIRECTIONS_QUERY,
          variables: {
            where
          }
        });
        setDirections(DirectionData.Directions);
        setLoading(false);
      } catch (err) {
        toast.error("Error getting Directions.");
        setLoading(false);
      }
    };
    fetchData();
  }, [client, where]);

  return { directions, loading };
};
const PrintDirections = ({ where, onComplete }) => {
  const { directions } = useDirections(where);

  const handlePrint = rawDirections => {
    printDirections(rawDirections);
  };
  const handlePrintAll = () => {
    printDirections(...directions);
  };

  return (
    <div className="print-directions">
      <div className="print-directions-header">
        <Title marginless>Print Directions</Title>
        <Field kind="group">
          <Control>
            <Button onClick={handlePrintAll}>
              <Icon>
                <FontAwesomeIcon icon="print" />
              </Icon>
              <span>Print All</span>
            </Button>
          </Control>
          <Control>
            <Button color="link" onClick={onComplete}>
              Close
            </Button>
          </Control>
        </Field>
      </div>
      <div className="print-directions-body">
        {directions.map(d => (
          <FormattedDirections
            end={d.DestinationLocation.RecId}
            handlePrint={() => handlePrint(d)}
            priority={d.Priority}
            start={d.OriginLocation.RecId}
            type={`Priority ${d.Priority}`}
          />
        ))}
      </div>
    </div>
  );
};

PrintDirections.propTypes = {
  where: PropTypes.object,
  onComplete: PropTypes.func
};

export default PrintDirections;
